import { Component, ViewChild, ViewChildren, forwardRef, Inject, Output, Input, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, FormGroup, ReactiveFormsModule, Validators  } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BaseGridComponent } from '../../Core/Abstract/basegrid.component';
import { EventsEmitterService } from '../../Core/Abstract/emitter.service';
import { SecurityService } from '../../Core/Security/security.service';
import { ClaccService } from './claccModal.service';
import { Observable } from 'rxjs';
import { LogService } from '../../Core/Abstract/log.service';
import { VisualsService } from '../../Core/Abstract/visuals.service';

@Component({
    selector: 'claccModal',
    templateUrl: './claccModal.component.html',
    providers: [ClaccService]
})

export class ClaccModalComponent extends BaseGridComponent<ClaccService>{
    @ViewChild('claccModal',{static: false}) public claccModal: ModalDirective;

    /*
    *  Modal handling
    */
    public accId = 0;
    @Output() valueChange = new EventEmitter();

    @Input()
    get value() {
        return this.accId;
    }

    set value(val) {
        this.accId = val;
        this.valueChange.emit(this.accId);
    }

    public showChildModal(): void {
        this.claccModal.show();
    }

    public hideChildModal(): void {
        this.claccModal.hide();
    }

    public passData(data): void {
        this.value = data['accId'];
        this.hideChildModal();
    }

    /*
     *  Grid
     */
    constructor(protected gridService: ClaccService,  
                private eventsEmitterService: EventsEmitterService, 
                protected securityService: SecurityService,
                logger: LogService,private fb: UntypedFormBuilder,
                visualsService: VisualsService) {

      super(securityService, logger, visualsService, gridService, "claccModal");

      this.loadVisuals();

      this.eventsEmitterService.languageChange.subscribe(
          langId => {
              this.loadVisuals();
              this.getValidationMessages();                
          }
      );

    }

}